<template>
  <span class="d-flex flex-row gap">
    <div class="d-flex flex-row" v-for="source in first" :key="source.name">
      <SourceWithCount
        :count="source.count"
        :source="source.name"
      ></SourceWithCount>
    </div>

    <div v-if="last.length > 0">
      <b-button
        :id="id"
        class="count-ellipse bg-grey-100 text-grey-700 fw-400 text-nowrap p-0"
        >{{ `+${last.length}` }}</b-button
      >
      <b-popover :target="id" triggers="hover" placement="top">
        <div class="d-flex flex-row gap">
          <SourceWithCount
            v-for="source in last"
            :key="source.name"
            :count="source.count"
            :source="source.name"
          ></SourceWithCount>
        </div>
      </b-popover>
    </div>
  </span>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import SourceWithCount from './SourceWithCount.vue'
import { BPopover, BButton } from 'bootstrap-vue'
export default {
  name: 'SourcesCount',
  components: { SourceWithCount, BPopover, BButton },
  props: {
    showZero: {
      type: Boolean,
      default: true
    },
    sources: {
      type: Array,
      default: () => []
    }, // [{name:"facebook",count:10}]
    maxTag: {
      type: Number,
      default: 3
    }
  },
  methods: {
    filterZero(source) {
      return this.showZero ? source.count >= 0 : source.count > 0
    }
  },
  computed: {
    id() {
      return `popover-social-${uuidv4()}`
    },
    sourcesFilter() {
      return this.sources.filter((source) => this.filterZero(source))
    },
    first() {
      return this.sourcesFilter.slice(0, this.maxTag)
    },
    last() {
      return this.sourcesFilter.slice(this.maxTag, this.sources.length)
    }
  }
}
</script>

<style scoped>
.count-ellipse {
  color: #000000;
  padding: 0;
  border-radius: 50%;
  padding: 4px;
  cursor: pointer;
  width: 20px;
  height: 20px;
  font-size: 12px;
}
.gap {
  gap: 4px;
}
</style>
